import Graficos from './Grafico/Graficos';


function App() {
  return (
    <div > 
      <center><h1>Gráficos</h1></center>
      <Graficos/>
    </div>
  );
}

export default App;
